import { BarChart } from "src/design";
import { Card } from "src/design/Card";
import { useTranslation } from "react-i18next";
import { PopularTimePoint } from "src/data/admin/types/analytics";
import { AnalyticsCardHeader } from "./AnalyticsCardHeader";

interface Props {
  data: PopularTimePoint[];
}

export const PopularBookingTimes = ({ data }: Props) => {
  const { t } = useTranslation();
  const bookingsKey = t("analytics.popularTimes.bookings");

  const chartData = data.map((point) => ({
    name: `${point.hour}h`,
    [bookingsKey]: point.count,
  }));

  return (
    <Card sx={{ flexDirection: "row", gap: 0, height: "100%" }}>
      <AnalyticsCardHeader
        title={t("analytics.popularTimes.title")}
        subtitle={t("analytics.popularTimes.subtitle")}
      />
      <BarChart data={chartData} dataKeys={[bookingsKey]} yAxis />
    </Card>
  );
};
